
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M19.9302 8.35L16.3301 10.03L14.0001 7.7V6.3L16.3301 3.97L19.9302 5.65C20.3102 5.83 20.7502 5.66 20.9302 5.29C21.1102 4.91 20.9402 4.47 20.5702 4.29L16.6501 2.46C16.2701 2.28 15.8202 2.36 15.5202 2.66L13.7801 4.4C13.6001 4.16 13.3201 4 13.0001 4C12.4501 4 12.0001 4.45 12.0001 5V6H8.82015C8.34015 4.66 6.96015 3.75 5.40015 4.06C4.23015 4.29 3.27015 5.25 3.05015 6.42C2.80015 7.76 3.45015 8.96 4.48015 9.58L7.08015 18H5.50015C4.67015 18 4.00015 18.67 4.00015 19.5C4.00015 20.33 4.67015 21 5.50015 21H15.5001C16.3301 21 17.0001 20.33 17.0001 19.5C17.0001 18.67 16.3301 18 15.5001 18H13.3801L8.41015 8.77C8.58015 8.53 8.72015 8.28 8.82015 8H12.0001V9C12.0001 9.55 12.4501 10 13.0001 10C13.3201 10 13.6001 9.84 13.7801 9.6L15.5202 11.34C15.8202 11.64 16.2701 11.72 16.6501 11.54L20.5702 9.71C20.9501 9.53 21.1102 9.09 20.9302 8.71C20.7502 8.34 20.3102 8.17 19.9302 8.35ZM6.00015 8C5.45015 8 5.00015 7.55 5.00015 7C5.00015 6.45 5.45015 6 6.00015 6C6.55015 6 7.00015 6.45 7.00015 7C7.00015 7.55 6.55015 8 6.00015 8Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-precision-manufacturing`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPrecisionManufacturing

    ```js
    <b-new-b-icon-precision-manufacturing />
    ```
</docs>


